// extracted by mini-css-extract-plugin
export default {"root":"loginFrame_root__NrGC8","content":"loginFrame_content__PV9p4"};